var CompliancePlanColumnIdName;
(function (CompliancePlanColumnIdName) {
    CompliancePlanColumnIdName[CompliancePlanColumnIdName["BP_CEID"] = 'BP CEID'] = "BP_CEID";
    CompliancePlanColumnIdName[CompliancePlanColumnIdName["BP_NAME"] = 'BP Name'] = "BP_NAME";
    CompliancePlanColumnIdName[CompliancePlanColumnIdName["COUNTRY"] = 'Country'] = "COUNTRY";
    CompliancePlanColumnIdName[CompliancePlanColumnIdName["IOT"] = 'GEO'] = "IOT";
    CompliancePlanColumnIdName[CompliancePlanColumnIdName["IMT"] = 'Market'] = "IMT";
    CompliancePlanColumnIdName[CompliancePlanColumnIdName["START_DATE"] = 'Review start date'] = "START_DATE";
    CompliancePlanColumnIdName[CompliancePlanColumnIdName["actions"] = 'Actions'] = "actions";
    CompliancePlanColumnIdName[CompliancePlanColumnIdName["COUNTRY_ISO"] = 'COUNTRY_ISO'] = "COUNTRY_ISO";
})(CompliancePlanColumnIdName || (CompliancePlanColumnIdName = {}));
var CompliancePlanLogColumnIdName;
(function (CompliancePlanLogColumnIdName) {
    CompliancePlanLogColumnIdName[CompliancePlanLogColumnIdName["ACTION_TIMESTAMP"] = 'Time'] = "ACTION_TIMESTAMP";
    CompliancePlanLogColumnIdName[CompliancePlanLogColumnIdName["ACTION_COMMENT"] = 'Changes made'] = "ACTION_COMMENT";
    CompliancePlanLogColumnIdName[CompliancePlanLogColumnIdName["USER_EMAIL"] = ' Changed by'] = "USER_EMAIL";
})(CompliancePlanLogColumnIdName || (CompliancePlanLogColumnIdName = {}));
var CompliancePlanController = (function () {
    function CompliancePlanController(settings, env, $compile, $filter, socket, $scope, Dialog, notify, DTOptionsBuilder, DTColumnBuilder, DTColumnDefBuilder) {
        var _this = this;
        this.settings = settings;
        this.env = env;
        this.$compile = $compile;
        this.$filter = $filter;
        this.socket = socket;
        this.$scope = $scope;
        this.Dialog = Dialog;
        this.notify = notify;
        this.DTOptionsBuilder = DTOptionsBuilder;
        this.DTColumnBuilder = DTColumnBuilder;
        this.DTColumnDefBuilder = DTColumnDefBuilder;
        this.itemsLoaded = false;
        this.logLoaded = false;
        this.processing = true;
        this.exportFired = false;
        this.importingExcel = false;
        this.tableItems = [];
        this.logItems = [];
        this.docTable = [];
        this.backendModuleName = 'admin/complianceplan/compliance-plan';
        this.scopePrefix = 'admin.complianceList';
        this.scopeDeleteRecord = this.scopePrefix + ".delete";
        this.scopeUpdateRecord = this.scopePrefix + ".update";
        this.scopeCreateRecord = this.scopePrefix + ".insert";
        this.scopeExport = this.scopePrefix + ".export";
        this.scopeDeleteAll = this.scopePrefix + ".deleteall";
        this.scopeImportFromExcel = this.scopePrefix + ".importFromExcel";
        this.scopeReplaceFromExcel = this.scopePrefix + ".replaceAllFromExcel";
        this.table = {
            dtColumns: {},
            dtInstance: {},
            filter: false,
            filterParams: {},
            filters: { BP: '' },
            search: '',
            select_options: {},
            visible: 0
        };
        this.tableLog = {
            dtColumns: {},
            dtInstance: {},
            filter: false,
            filterParams: {},
            filters: { ACTION_TIMESTAMP: '' },
            search: '',
            select_options: {},
            visible: 0
        };
        // CREATE
        this.socket.forward(this.scopeCreateRecord, this.$scope);
        this.$scope.$on("socket:" + this.scopeCreateRecord, function (event, data) {
            if (_this.isIncomingErrors(data)) {
                _this.handleIncomingErrors(data.error, 'Create a record');
                _this.notify.error("Unable to create a record");
            }
            else {
                _this.notify.success('Record successfuly added');
                _this.tableLog.dtInstance.DataTable.ajax.reload(null, true);
            }
            _this.table.dtInstance.DataTable.ajax.reload(null, true);
        });
        // DELETE
        this.socket.forward(this.scopeDeleteRecord, this.$scope);
        this.$scope.$on("socket:" + this.scopeDeleteRecord, function (event, data) {
            if (_this.isIncomingErrors(data)) {
                _this.handleIncomingErrors(data.error, 'Delete record');
                _this.notify.error("Unable to delete record");
            }
            else {
                _this.notify.success('Record was deleted successful!');
                _this.tableLog.dtInstance.DataTable.ajax.reload(null, true);
            }
            _this.table.dtInstance.DataTable.ajax.reload(null, true);
        });
        // UPDATE
        this.socket.forward(this.scopeUpdateRecord, this.$scope);
        this.$scope.$on("socket:" + this.scopeUpdateRecord, function (event, data) {
            if (_this.isIncomingErrors(data)) {
                _this.handleIncomingErrors(data.error, 'Update the record');
                _this.notify.error("Unable to update the record");
            }
            else {
                _this.notify.success('Comliance plan successfuly updated!');
                _this.tableLog.dtInstance.DataTable.ajax.reload(null, true);
            }
            _this.table.dtInstance.DataTable.ajax.reload(null, true);
        });
        // DOWNLOAD EXCEL
        this.socket.forward(this.scopeExport, this.$scope);
        this.$scope.$on("socket:" + this.scopeExport, function (event, data) {
            _this.exportFired = false;
            if (_this.isIncomingErrors(data)) {
                _this.handleIncomingErrors(data.error, 'Exporting list');
                return _this.notify.error("Can't to export list");
            }
            else {
                _this.downloadFile(data.payload, 'DMT-COMPLIANCE-PLAN');
                _this.tableLog.dtInstance.DataTable.ajax.reload(null, true);
                return _this.notify.success('Compliance plan with BP list was exported successful!');
            }
        });
        // DELETE ALL
        this.socket.forward(this.scopeDeleteAll, this.$scope);
        this.$scope.$on("socket:" + this.scopeDeleteAll, function (event, data) {
            if (_this.isIncomingErrors(data)) {
                _this.handleIncomingErrors(data.error, 'Delete all records');
                _this.notify.error("Unable to delete all records");
            }
            else {
                _this.notify.success('All records was deleted successful!');
                _this.tableLog.dtInstance.DataTable.ajax.reload(null, true);
            }
            _this.table.dtInstance.DataTable.ajax.reload(null, true);
        });
        // UPLOADADED
        this.socket.forward(this.scopeImportFromExcel, this.$scope);
        this.$scope.$on("socket:" + this.scopeImportFromExcel, function (event, data) {
            _this.importingExcel = false;
            if (_this.isIncomingErrors(data)) {
                _this.handleIncomingErrors(data.error, 'Upload and Add from Excel');
                _this.notify.error("Can't to upload and add from Excel");
            }
            else {
                _this.notify.success('Uploaded and add from Excel successful!');
                _this.tableLog.dtInstance.DataTable.ajax.reload(null, true);
            }
            _this.table.dtInstance.DataTable.ajax.reload(null, true);
        });
        // UPLOAD REPLACE
        this.socket.forward(this.scopeReplaceFromExcel, this.$scope);
        this.$scope.$on("socket:" + this.scopeReplaceFromExcel, function (event, data) {
            _this.importingExcel = false;
            if (_this.isIncomingErrors(data)) {
                _this.handleIncomingErrors(data.error, 'Upload and Replace from Excel');
                _this.notify.error("Can't to upload and replace from Excel");
            }
            else {
                _this.notify.success('Uploaded and replace from Excel successful!');
                _this.tableLog.dtInstance.DataTable.ajax.reload(null, true);
            }
            _this.table.dtInstance.DataTable.ajax.reload(null, true);
        });
    }
    CompliancePlanController.prototype.$onInit = function () {
        var _this = this;
        this.signalWrongResponse = '';
        this.table.dtColumns = this.buildColumns();
        this.table.dtOptions = this.DTOptionsBuilder.newOptions()
            .withIBMTheme()
            .withOption('alphabetColumnIndex', 3)
            .withOption('ajax', this.buildAjaxOption())
            .withOption('processing', true)
            .withOption('serverSide', true)
            .withOption('searchDelay', 1000)
            .withOption('order', [[3, 'asc']]) // Default sorting by BP name
            .withPaginationType('full_numbers')
            .withOption('createdRow', function (row) {
            _this.$compile(angular.element(row).contents())(_this.$scope);
        })
            .withOption('drawCallback', function (settings) {
            _this.processing = false;
        });
        this.tableLog.dtColumns = this.buildLogColumns();
        this.tableLog.dtOptions = this.DTOptionsBuilder.newOptions()
            .withIBMTheme()
            .withOption('ajax', this.buildLogAjaxOption())
            .withOption('processing', true)
            .withOption('serverSide', true)
            .withOption('searchDelay', 1000)
            .withOption('order', [[0, 'desc']]) // Default sorting by time
            .withPaginationType('full_numbers')
            .withOption('createdRow', function (row) {
            _this.$compile(angular.element(row).contents())(_this.$scope);
        })
            .withOption('drawCallback', function (settings) {
            _this.processing = false;
        });
    };
    /**
     * Function to add new row in DB
     */
    CompliancePlanController.prototype.addRow = function (event) {
        var _this = this;
        var tit = 'Add Compliance Plan record';
        var DEFAULT_SELECTION = '-Please select-';
        var result = this.extractCountry();
        var endDate = new Date();
        endDate.setFullYear(endDate.getFullYear() + 1);
        var emptyItem = {
            bpCeid: '',
            bpName: '',
            country: DEFAULT_SELECTION,
            countryIso: '',
            imt: DEFAULT_SELECTION,
            iot: DEFAULT_SELECTION,
            startDate: new Date()
        };
        var items = {
            icon: 'QUESTION',
            message: 'Are you sure, you want to add a new record to existing list?',
            title: tit,
            tree: result.tree,
            // tslint:disable-next-line:object-literal-sort-keys
            iots: Object.keys(result.tree).sort(),
            imts: result.imts,
            newItem: emptyItem,
            listIOTs: function (tree) { return Object.keys(tree).sort(); },
            listIMTs: function (tree, iot) { return Object.keys(tree[iot] || {}).sort(); },
            listCountries: function (tree, iot, imt) { return (tree[iot] || {})[imt] || []; }
        };
        this.Dialog.updateValidForm(event, items, CompliancePlanController.TEMPLATE_CONFIRM)
            .then(function (dResult) {
            if (!dResult.confirm) {
                return;
            }
            _this.Dialog.updateValidForm(event, items, 'complianceplan-add.html')
                .then(function (answer) {
                var newItem = answer.newItem;
                items.newItem = newItem;
                var date = newItem.startDate;
                newItem.startDate = date.getFullYear() + "-" + (date.getMonth() + 1) + "-" + date.getDate();
                newItem.countryIso = _this.settings.country_list
                    .filter(function (num) { return num.country === newItem.country; })[0].short;
                _this.socket.emit('module', {
                    module: {
                        application: 'dmt',
                        data: newItem,
                        email: _this.env.user.email,
                        function: 'insertRecord',
                        scopeBack: _this.scopeCreateRecord,
                        script: _this.backendModuleName,
                        token: _this.env.user.token
                    }
                });
            });
        });
    };
    /**
     * Function to delete a row in DB
     */
    CompliancePlanController.prototype.deleteRow = function (event, rowId) {
        var _this = this;
        var rowData = this.tableItems[rowId];
        this.Dialog.confirmDelete(event, rowData).then(function (dResult) {
            if (dResult) {
                var dataToDelete = {
                    bpCeid: rowData[CompliancePlanColumnIdName[CompliancePlanColumnIdName.BP_CEID]],
                    country: rowData[CompliancePlanColumnIdName[CompliancePlanColumnIdName.COUNTRY]],
                    countryIso: rowData[CompliancePlanColumnIdName[CompliancePlanColumnIdName.COUNTRY_ISO]],
                    startDate: new Date(rowData[CompliancePlanColumnIdName[CompliancePlanColumnIdName.START_DATE]])
                };
                _this.socket.emit('module', {
                    module: {
                        application: 'dmt',
                        data: dataToDelete,
                        email: _this.env.user.email,
                        function: 'deleteRecord',
                        scopeBack: _this.scopeDeleteRecord,
                        script: _this.backendModuleName,
                        token: _this.env.user.token
                    }
                });
            }
        });
    };
    /**
     * Function to update the row of Compliance plan in DB
     */
    CompliancePlanController.prototype.updateRow = function (event, rowId) {
        var _this = this;
        var rowData = this.tableItems[rowId];
        var result = this.extractCountry();
        var orginalData = {
            bpCeid: rowData[CompliancePlanColumnIdName[CompliancePlanColumnIdName.BP_CEID]],
            country: rowData[CompliancePlanColumnIdName[CompliancePlanColumnIdName.COUNTRY]],
            countryIso: rowData[CompliancePlanColumnIdName[CompliancePlanColumnIdName.COUNTRY_ISO]],
            startDate: new Date(rowData[CompliancePlanColumnIdName[CompliancePlanColumnIdName.START_DATE]])
        };
        var dataToUpdate = {
            bpCeid: rowData[CompliancePlanColumnIdName[CompliancePlanColumnIdName.BP_CEID]],
            bpName: rowData[CompliancePlanColumnIdName[CompliancePlanColumnIdName.BP_NAME]],
            country: rowData[CompliancePlanColumnIdName[CompliancePlanColumnIdName.COUNTRY]],
            countryIso: rowData[CompliancePlanColumnIdName[CompliancePlanColumnIdName.COUNTRY_ISO]],
            imt: rowData[CompliancePlanColumnIdName[CompliancePlanColumnIdName.IMT]],
            iot: rowData[CompliancePlanColumnIdName[CompliancePlanColumnIdName.IOT]],
            startDate: new Date(rowData[CompliancePlanColumnIdName[CompliancePlanColumnIdName.START_DATE]])
        };
        var updatedData = {
            tree: result.tree,
            // tslint:disable-next-line:object-literal-sort-keys
            iots: Object.keys(result.tree).sort(),
            imts: result.imts,
            content: dataToUpdate,
            orgContent: orginalData,
            listIOTs: function (tree) { return Object.keys(tree).sort(); },
            listIMTs: function (tree, iot) {
                return Object.keys(tree[iot] || {}).sort();
            },
            listCountries: function (tree, iot, imt) {
                return (tree[iot] || {})[imt] || [];
            }
        };
        this.Dialog.updateValidForm(event, updatedData, 'complianceplan-edit.html')
            .then(function (dResult) {
            var item = updatedData.content;
            var orgItem = updatedData.orgContent;
            var date = item.startDate;
            item.startDate = date.getFullYear() + "-" + (date.getMonth() + 1) + "-" + date.getDate();
            item.countryIso = _this.settings.country_list
                .filter(function (num) { return num.country === item.country; })[0].short;
            _this.socket.emit('module', {
                module: {
                    application: 'dmt',
                    data: item,
                    email: _this.env.user.email,
                    function: 'updateRecord',
                    orgData: orgItem,
                    scopeBack: _this.scopeUpdateRecord,
                    script: _this.backendModuleName,
                    token: _this.env.user.token
                }
            });
        });
    };
    CompliancePlanController.prototype.buildAjaxOption = function () {
        var _this = this;
        return {
            url: '/api/admin/compliance-plan',
            // tslint:disable-next-line:object-literal-sort-keys
            type: 'POST',
            beforeSend: function (request) {
                _this.processing = true;
                _this.itemsLoaded = false;
                request.setRequestHeader('Authorization', "Bearer " + _this.env.user.token);
            },
            data: function (draw) {
                var dt = _this.table.dtInstance.DataTable;
                if (dt && dt.context && Array.isArray(dt.context)) {
                    draw.alphabetSearch = dt.context[0].alphabetSearch;
                }
            },
            dataSrc: function (data) {
                _this.tableItems = data.data;
                _this.itemsLoaded = true;
                _this.processing = false;
                return data.data;
            }, error: function (xhr, errorMessage, thrown) {
                // Display message, when an error appears
                var items = {
                    icon: 'ERROR',
                    message: 'Unable to retrieve Compliance Plan data from the server for the following reason:<br><br> ',
                    title: 'Server Error'
                };
                if (xhr.responseText) {
                    items.message += "<b>" + xhr.responseText + "</b>\n                    <br>Please try again, if the problem persists contact the DMT System Administrators";
                }
                else {
                    if (errorMessage === 'timeout' || thrown.toLowerCase().indexOf('time-out') > -1) {
                        items.message += '<b>The server took too long to send the data and timed-out -&nbsp;</b><br>';
                    }
                    items.message += "<b style=\"color:red\">" + errorMessage + "/" + thrown + "</b><br><br>\n                    This is usually a temporary problem.\n                    &nbsp;Please try again, if the problem persists contact the DMT System Administrators";
                }
                _this.Dialog.updateValidForm(undefined, items, CompliancePlanController.TEMPLATE_CONFIRM).then(function (dResult) {
                    _this.signalWrongResponse = items.message.replace(new RegExp('<br><br>', 'g'), ' ');
                });
                // Turns off the processing bar
                _this.itemsLoaded = true;
                _this.importingExcel = false;
                $('#table_processing').hide();
            }
        };
    };
    CompliancePlanController.prototype.buildLogAjaxOption = function () {
        var _this = this;
        return {
            url: '/api/admin/compliance-plan-log',
            // tslint:disable-next-line:object-literal-sort-keys
            type: 'POST',
            beforeSend: function (request) {
                _this.processing = true;
                _this.logLoaded = false;
                request.setRequestHeader('Authorization', "Bearer " + _this.env.user.token);
            },
            data: function (draw) {
                var dt = _this.tableLog.dtInstance.DataTable;
                if (dt && dt.context && Array.isArray(dt.context)) {
                    draw.alphabetSearch = dt.context[0].alphabetSearch;
                }
            },
            dataSrc: function (data) {
                _this.logItems = data.data;
                _this.logLoaded = true;
                _this.processing = false;
                return data.data;
            }, error: function (xhr, errorMessage, thrown) {
                // Display message, when an error appears
                var items = {
                    icon: 'ERROR',
                    message: 'Unable to retrieve Compliance Plan log from the server for the following reason:<br><br> ',
                    title: 'Server Error'
                };
                if (xhr.responseText) {
                    items.message += "<b>" + xhr.responseText + "</b>\n                    <br>Please try again, if the problem persists contact the DMT System Administrators";
                }
                else {
                    if (errorMessage === 'timeout' || thrown.toLowerCase().indexOf('time-out') > -1) {
                        items.message += '<b>The server took too long to send the data and timed-out -&nbsp;</b><br>';
                    }
                    items.message += "<b style=\"color:red\">" + errorMessage + "/" + thrown + "</b><br><br>\n                    This is usually a temporary problem.\n                    &nbsp;Please try again, if the problem persists contact the DMT System Administrators";
                }
                _this.Dialog.updateValidForm(undefined, items, CompliancePlanController.TEMPLATE_CONFIRM).then(function (dResult) {
                    _this.signalWrongResponse = items.message.replace(new RegExp('<br><br>', 'g'), ' ');
                });
                // Turns off the processing bar
                _this.logLoaded = true;
                $('#table_processing').hide();
            }
        };
    };
    CompliancePlanController.prototype.generateColumn = function (columnName, renderFn) {
        var columnId = CompliancePlanColumnIdName[columnName] || CompliancePlanLogColumnIdName[columnName];
        var orderable = columnId === CompliancePlanColumnIdName[CompliancePlanColumnIdName.BP_NAME]
            || columnId === CompliancePlanLogColumnIdName[CompliancePlanLogColumnIdName.ACTION_TIMESTAMP];
        return this.DTColumnBuilder
            .newColumn(columnId)
            .withOption('name', columnId)
            .withOption('orderable', orderable) //FIXME - tmp
            .withTitle(columnName ? columnName : columnId)
            .renderWith(renderFn ? renderFn : function (data) { return data; }); // FIXME - check an emptry fn
    };
    CompliancePlanController.prototype.buildColumns = function () {
        var _this = this;
        return [
            this.generateColumn(CompliancePlanColumnIdName.IOT),
            this.generateColumn(CompliancePlanColumnIdName.IMT),
            this.generateColumn(CompliancePlanColumnIdName.COUNTRY),
            this.generateColumn(CompliancePlanColumnIdName.BP_NAME),
            this.generateColumn(CompliancePlanColumnIdName.BP_CEID),
            this.generateColumn(CompliancePlanColumnIdName.START_DATE, function (data) {
                return _this.$filter('date')(new Date(data), CompliancePlanController.DATE_FORMAT);
            }),
            this.generateColumn(CompliancePlanColumnIdName.actions, this.actionButtons)
        ];
    };
    CompliancePlanController.prototype.buildLogColumns = function () {
        return [
            this.generateColumn(CompliancePlanLogColumnIdName.ACTION_TIMESTAMP),
            this.generateColumn(CompliancePlanLogColumnIdName.ACTION_COMMENT),
            this.generateColumn(CompliancePlanLogColumnIdName.USER_EMAIL)
        ];
    };
    CompliancePlanController.prototype.actionButtons = function (data, type, full, meta) {
        return "\n        <md-button class=\"edit-button md-button md-ink-ripple md-2ink-ripple\" ng-click=\"vm.updateRow($event, '" + meta.row + "')\"\n            ng-disabled=\"vm.isSaving\" aria-label=\"Edit\">\n                <md-icon class=\"black_icon\" md-svg-icon='edit_pen'></md-icon>\n        </md-button>\n        <md-button class=\"delete-button md-button md-ink-ripple\" ng-click=\"vm.deleteRow($event, '" + meta.row + "')\"\n            ng-disabled=\"vm.isSaving\" aria-label=\"Delete\">\n                <md-icon md-svg-icon='delete'></md-icon>\n        </md-button>";
    };
    /**
     * Function to extract country
     */
    CompliancePlanController.prototype.extractCountry = function () {
        var result = this.settings.country_list.filter(function (el) { return el.ic === 'Country'; }).reduce(function (r, country) {
            r.tree[country.imt] = r.tree[country.imt] || {};
            r.tree[country.imt][country.imt_name] = r.tree[country.imt][country.imt_name] || [];
            r.tree[country.imt][country.imt_name].push(country.country);
            r.tree[country.imt][country.imt_name].sort();
            r.imts[country.imt] = r.imts[country.imt] || [];
            r.imts[country.imt].push(country.imt_name);
            r.imts[country.imt] = _.uniq(r.imts[country.imt]);
            r.imts[country.imt].sort();
            return r;
        }, { tree: {}, imts: {} });
        return result;
    };
    /**
     * Function to handle all errors
     */
    CompliancePlanController.prototype.isIncomingErrors = function (data) {
        if (data && data.error) {
            if (data.error.validationErrors.length || data.error.errors.length) {
                return true;
            }
        }
        else {
            return false;
        }
    };
    /**
     * Function to show all errors
     */
    CompliancePlanController.prototype.handleIncomingErrors = function (data, name) {
        var allErrorsInfo = {
            allErrors: data,
            windowName: name
        };
        this.Dialog.showingErrors(event, allErrorsInfo, 'showing-errors.html').then(function (dResult) {
            if (dResult) {
                return;
            }
        });
        return;
    };
    // tslint:disable-next-line:typedef
    CompliancePlanController.prototype.openActionMenu = function ($mdOpenMenu, event) {
        $mdOpenMenu(event);
    };
    /**
     * Function to prepare the DB info for export
     */
    CompliancePlanController.prototype.exportComplinacePlan = function () {
        this.exportFired = true;
        this.socket.emit('module', {
            module: {
                application: 'dmt',
                data: {},
                email: this.env.user.email,
                function: 'exportList',
                scopeBack: this.scopeExport,
                script: this.backendModuleName,
                token: this.env.user.token
            }
        });
    };
    /**
     * Function to delete all items in DB
     */
    CompliancePlanController.prototype.deleteAllRows = function (event) {
        var _this = this;
        this.Dialog.confirmDelete(event).then(function (dResult) {
            if (dResult) {
                _this.socket.emit('module', {
                    module: {
                        application: 'dmt',
                        function: 'deleteAllRecords',
                        scopeBack: _this.scopeDeleteAll,
                        script: _this.backendModuleName,
                        token: _this.env.user.token,
                        email: _this.env.user.email
                    }
                });
            }
        });
        return;
    };
    /**
     * Function to upload list
     */
    CompliancePlanController.prototype.uploadList = function (event) {
        var _this = this;
        var tit = 'Upload new list';
        var items = {
            icon: 'QUESTION',
            message: 'Do you want to add items to existing records or replace the existing list?',
            title: tit
        };
        this.Dialog.updateValidForm(event, items, 'complianceplan-update-add.html').then(function (dResult) {
            if (dResult.confirm) {
                _this.uploadFilesAdd(dResult.data[0]);
            }
            else {
                var tit1 = 'Replace existing list';
                var items1 = {
                    icon: 'QUESTION',
                    message: 'Are you sure you want to completely replace the existing list?',
                    title: tit1
                };
                _this.Dialog.updateValidForm(event, items1, 'newclient-update-replace.html').then(function (dResult1) {
                    if (dResult1.confirm) {
                        _this.uploadFilesReplace(dResult1.data[0]);
                    }
                });
            }
        });
        return;
    };
    /**
     * Functions to prepare the files for file upload ADD
     */
    CompliancePlanController.prototype.uploadFilesAdd = function (file) {
        if (file) {
            this.socket.emit('module', {
                module: {
                    application: 'dmt',
                    data: file,
                    function: 'importFromExcel',
                    scopeBack: this.scopeImportFromExcel,
                    script: this.backendModuleName,
                    email: this.env.user.email,
                    token: this.env.user.token
                }
            });
        }
        this.importingExcel = true;
    };
    /**
     * Functions to prepare the files for file upload REPLACE
     */
    CompliancePlanController.prototype.uploadFilesReplace = function (file) {
        if (file) {
            this.socket.emit('module', {
                module: {
                    application: 'dmt',
                    data: file,
                    function: 'replaceAllFromExcel',
                    scopeBack: this.scopeReplaceFromExcel,
                    script: this.backendModuleName,
                    email: this.env.user.email,
                    token: this.env.user.token
                }
            });
        }
        this.importingExcel = true;
    };
    /**
     * Function to download files
     */
    CompliancePlanController.prototype.downloadFile = function (file, name) {
        var a = document.createElement('A');
        document.body.appendChild(a);
        a.setAttribute('style', 'display: none;');
        var url = window.URL.createObjectURL(new Blob([file], {
            type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
        }));
        a.setAttribute('href', url);
        var d = new Date().toDateString();
        a.setAttribute('download', name + " " + d + ".xlsx");
        a.click();
    };
    CompliancePlanController.$inject = [
        'settings',
        'env',
        '$compile',
        '$filter',
        'socket',
        '$scope',
        'Dialog',
        'notify',
        'DTOptionsBuilder',
        'DTColumnBuilder',
        'DTColumnDefBuilder'
    ];
    CompliancePlanController.DATE_FORMAT = 'd MMM yyyy';
    CompliancePlanController.TEMPLATE_CONFIRM = 'confirm-prompt.html';
    return CompliancePlanController;
}());
// tslint:disable-next-line:max-classes-per-file
var CompliancePlanComponent = (function () {
    function CompliancePlanComponent() {
        this.templateUrl = 'complianceplan.html';
        this.controllerAs = 'vm';
        this.controller = CompliancePlanController;
    }
    return CompliancePlanComponent;
}());
angular
    .module('application')
    .config(function ($mdIconProvider) {
    return $mdIconProvider.icon('edit_pen1', '/public/icons/ic_mode_edit_black_24px.svg');
})
    .component('complianceplanSection', new CompliancePlanComponent());

//# sourceMappingURL=complianceplan.component.js.map
